import React, { memo } from 'react';
import { Modal } from 'antd';
import PurchaseOrderDetail from '.';

export type PurchaseOrderDetailModalProps = {
  visible: boolean;
  onCancel: () => void;
  poid: number;
};

const PurchaseOrderDetailModal = (props: PurchaseOrderDetailModalProps) => {
  const { visible, onCancel, poid } = props;

  return (
    (<Modal
      open={visible}
      title="Purchase Order Detail Modal"
      footer={null}
      onCancel={onCancel}
      width={1400}
    >
      <PurchaseOrderDetail poid={poid} />
    </Modal>)
  );
};

export default memo(PurchaseOrderDetailModal);
